export const PRODUCT = '/product'
export const HOME = '/'
export const CART = '/cart'
export const CHECKOUT = '/checkout'
export const ORDERS = '/orders'
export const COUPONS = '/my-account/coupons'
export const MY_REVIEWS = '/my-reviews'
export const PROFILE = '/profile'
export const EDIT_PROFILE = '/editprofile'
export const ADDRESS = '/address'
export const CUSTOMER_SERVICE = '/contactus'
export const DELETE_ACCOUNT = '/delete-account'
export const TERMS_OF_SERVICE = '/terms-of-service'
export const PRIVACY_POLICY = '/privacy-policy'
export const LOGIN = '/login'
export const REGISTER = '/register'
export const LANGUAGE = '/language'
export const OVERVIEW = '/overview'
export const WISHLIST = '/wishlist'
export const CATEGORIES = '/categories'

export const RECENTISSUES = '/recent/issues'
export const LOGINRELATED = '/login/related'
export const REFUNDRELATED = '/refund/related'
export const EMIRELATED = '/emi/related'

export const OFFERSRELATED = '/offers/related'
export const CONTACTUS = '/contactus'

// Orders that will not change status anymore, so no need to keep polling them
export const ORDER_TERMINAL_STATUSES = [
	'delivered',
	'cancelled',
	'returned',
	'return_completed'
]

// Interval used to refresh order status (e.g. admin marks order as delivered)
export const ORDER_STATUS_POLL_INTERVAL = 30_000
